import { orderByLocale, removeExcludedField } from './helpers';
import { countriesCodes } from '../../../i18n/localeHelpers';
import { defaultOptions, defaultArrangedOptions } from './countryOptions';
import { getColombiaSpecificOptions } from './localeSpecific/colombia';
import { getPeruSpecificOptions } from './localeSpecific/peru';

const defaultInputOptions = { ...defaultOptions };

export const byLocale =
  (locale: string) =>
  (
    inputs: Array<Record<string, unknown>>,
    fields: Record<string, unknown>,
    onValuesChange: (newValue: unknown) => void,
    bankEntities: Array<Record<string, string>> = []
  ) => {
    const getLocaleSpecificOptions = () => {
      switch (locale) {
        case countriesCodes.colombia: {
          return getColombiaSpecificOptions(inputs, fields, onValuesChange, bankEntities);
        }
        case countriesCodes.peru: {
          return getPeruSpecificOptions(inputs, fields, onValuesChange, bankEntities);
        }
        default: {
          const inputsCopy = inputs;

          const withoutExcluded = removeExcludedField(inputsCopy, [defaultInputOptions.exclude]);

          const orderedInputOptions = orderByLocale(defaultArrangedOptions, withoutExcluded);

          return orderedInputOptions;
        }
      }
    };

    const filteredResults = getLocaleSpecificOptions();

    const isCollectiveIdsInput = (input: Record<string, unknown>) => input?.name === 'collectiveIds';

    return [
      ...filteredResults.filter((input: Record<string, unknown>) => !isCollectiveIdsInput(input)),
      ...filteredResults.filter(isCollectiveIdsInput)
    ];
  };
